import JsBarcode from 'jsbarcode';

/**
 * Renders a Code 128 barcode (order id) for thermal ticket printing.
 * Tries decreasing bar width until the bitmap fits maxWidthPx; if still too wide, scales down with crisp nearest-neighbor.
 */
export function generateOrderTicketBarcodeDataUrl(text: string, maxWidthPx: number): string {
  const value = text?.trim();
  if (!value || maxWidthPx < 48) {
    return '';
  }

  const height = 56;
  for (let barWidth = 6; barWidth >= 1; barWidth--) {
    const canvas = document.createElement('canvas');
    try {
      JsBarcode(canvas, value, {
        format: 'CODE128',
        width: barWidth,
        height,
        margin: 0,
        displayValue: false,
        background: '#ffffff',
        lineColor: '#000000',
      });
    } catch {
      continue;
    }
    if (canvas.width > 0 && canvas.width <= maxWidthPx) {
      return canvas.toDataURL('image/png');
    }
  }

  const canvas = document.createElement('canvas');
  try {
    JsBarcode(canvas, value, {
      format: 'CODE128',
      width: 1,
      height,
      margin: 0,
      displayValue: false,
      background: '#ffffff',
      lineColor: '#000000',
    });
  } catch {
    return '';
  }

  if (canvas.width <= maxWidthPx) {
    return canvas.toDataURL('image/png');
  }

  const out = document.createElement('canvas');
  out.width = maxWidthPx;
  out.height = Math.max(28, Math.round(canvas.height * (maxWidthPx / canvas.width)));
  const ctx = out.getContext('2d');
  if (!ctx) {
    return canvas.toDataURL('image/png');
  }
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, out.width, out.height);
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(canvas, 0, 0, out.width, out.height);
  return out.toDataURL('image/png');
}
